import styled from 'styled-components'

export const Pattern = styled.pattern``
